import { Component, inject, CUSTOM_ELEMENTS_SCHEMA, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { TranslationService } from '../../../services/translation.service';
import { ProfileClientService } from '../../../services/settings/profile-client.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, TranslatePipe], // ✅ Importar TranslatePipe
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SidebarComponent implements OnInit {
  private router = inject(Router);
  private translationService = inject(TranslationService);
  private cdr = inject(ChangeDetectorRef); // ✅ Inyectamos ChangeDetectorRef
  translations: any = {}; // 🔹 Se guardan las traducciones aquí
  constructor(

    private profileClientService: ProfileClientService
  ) { }

  typesProfiles: any[] = [];
  loading: boolean = true;

  loadProfiles() {
    this.profileClientService.getData("typeclients/actives").subscribe({
      next: (data) => {
        this.typesProfiles = data.map((item: any) => ({
          label: item.name,
          value: item.id
        }));
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        console.error("Error loading data", error);
      },
    });
  }

  ngOnInit() {
    // Suscribirse a cambios de idioma y traducciones
    this.translationService.getTranslations().subscribe(translations => {
      this.translations = translations;
      this.cdr.detectChanges(); // 🔹 Forzar actualización de la vista
    });

    this.loadProfiles();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  getTranslation(key: string): string {
    return this.translations[key] || key; // 🔹 Si no existe, devuelve la clave
  }
}
